import { takeLatest, eventChannel } from 'redux-saga';
import { put, call, fork, select, take } from 'redux-saga/effects';
import { fromJS } from 'immutable';
var Scroll  = require('react-scroll');
var scroll = Scroll.animateScroll;

import { sendBirdService } from '../utils/sendbird-service';
import { getUserId } from '../selectors/user-selectors';
import { getIsSendbirdUserLoading, getSendbirdUser, getSendbirdChannelURL } from '../selectors/sendbird-selectors';
import { reportError } from '../utils/error-handling-service';
import { RECEIVE_MESSAGE } from '../containers/discussion/constants';
import { UPDATE_USER } from '../containers/user-widget/constants';
import {
  LOAD_SENDBIRD_USER,
  LOAD_SENDBIRD_USER_SUCCESS,
  LOAD_SENDBIRD_USER_ERROR,
  LOAD_SENDBIRD_CHANNEL,
  LOAD_SENDBIRD_CHANNEL_SUCCESS,
  LOAD_SENDBIRD_CHANNEL_ERROR,
} from '../constants/sendbird';

/* eslint no-constant-condition: "off" */
export function* receiveMessageHandler(uniqueId) {
  const messageChannel = yield call(sendbirdChannelHandler, uniqueId);

  while (true) {
    let message = yield take(messageChannel);
    yield put({ type: RECEIVE_MESSAGE, message });
  }
}

function sendbirdChannelHandler(uniqueId) {
  return eventChannel(emitter => {
    let sendBird = sendBirdService.getSendbirdService();
    let ChannelHandler = new sendBird.ChannelHandler();

    ChannelHandler.onMessageReceived = (channel, message) => {
      emitter(message);
    };
    sendBird.addChannelHandler(uniqueId, ChannelHandler);

    // The subscriber must return an unsubscribe function
    return () => {
      sendBird.removeChannelHandler(uniqueId);
    };
  });
}

export function* setupSendbirdUser(actions) {

  try {
    let userId = yield select(getUserId);

    if (!userId) {
      yield take(UPDATE_USER);
      userId = yield select(getUserId);
    }
    // Login user to sendbird
    const sendbirdUser = yield call(sendBirdService.connectSendbirdUser, userId);
    yield put({ type: LOAD_SENDBIRD_USER_SUCCESS, sendbirdUser: fromJS(sendbirdUser) });

    // Setup handler to receive messages from anywhere in the app
    yield fork(receiveMessageHandler, Math.random());

  } catch(error) {
    reportError('LOAD_SENDBIRD_USER_ERROR', error.message);
    yield put({ type: LOAD_SENDBIRD_USER_ERROR, error });
  }
}

export function* checkSendbirdUserIsSetup() {

  const isSendbirdUserLoading = yield select(getIsSendbirdUserLoading);
  const sendbirdUser = yield select(getSendbirdUser);

  if (isSendbirdUserLoading) {
    yield take(LOAD_SENDBIRD_USER_SUCCESS);
  } else if (!sendbirdUser && !isSendbirdUserLoading) {
    yield put({ type: LOAD_SENDBIRD_USER });
    yield take(LOAD_SENDBIRD_USER_SUCCESS);
  }
}

export function* loadSendbirdChannel(action) {

  try {
    const sendbirdChannelURL = yield select(getSendbirdChannelURL);

    yield call(checkSendbirdUserIsSetup);

    const sendbirdChannel = yield call(sendBirdService.fetchSendbirdChannel, sendbirdChannelURL);
    yield put({ type: LOAD_SENDBIRD_CHANNEL_SUCCESS, sendbirdChannel });

  } catch(error) {
    reportError('LOAD_SENDBIRD_CHANNEL_ERROR', error.message);
    yield put({ type: LOAD_SENDBIRD_CHANNEL_ERROR, error });
  }
}

export function* watchLoadSendbirdChannel() {
  yield takeLatest(LOAD_SENDBIRD_CHANNEL, loadSendbirdChannel);
}

export function* watchSetupSendbirdUser() {
  yield takeLatest(LOAD_SENDBIRD_USER, setupSendbirdUser);
}

export default function* sendbirdSagas() {
  yield [
    fork(watchSetupSendbirdUser),
  ];
}



/** WEBPACK FOOTER **
 ** ./src/sagas/sendbird.js
 **/